import { FieldValues } from "react-hook-form";
import { Step } from "./Step";
import { StepperProps } from "./types";
import LoadingSpinner from "../LoadingSpinner";

export const Stepper = <T extends FieldValues>({
  activeStep,
  onSkip,
  onNext,
  onBack,
  isLoading = false,
  steps,
  isNextButtonLoading = false,
  onStepOptionSelect,
  onItemHover,
  size,
  isPreview,
  onExit,
}: StepperProps<T>) => {
  const totalSteps = steps?.filter((item) => !item.isOptional).length;

  if (!steps) return null;

  return isLoading ? (
    <LoadingSpinner />
  ) : (
    <Step
      size={size}
      isPreview={isPreview}
      onItemHover={onItemHover}
      onExit={onExit}
      stepNumber={activeStep + 1}
      step={steps[activeStep]}
      totalSteps={totalSteps}
      onStepOptionSelect={onStepOptionSelect}
      onBack={() => onBack(activeStep)}
      onNext={() => onNext(activeStep)}
      onSkip={onSkip}
      isNextButtonLoading={isNextButtonLoading}
    />
  );
};
